import React, { useEffect, useState } from 'react';

import Logo from '../../shared/logo/logo';
import { classnames } from '../../../utils/classnames';
import RadioButtonGroup from '../../shared/radio-button/radio-button';
import VisitWidget from './visit';
import BookingAppointment from './appointment';
import { TabContent, TabNavItem } from './tab';
import Preloader from '../../shared/preloader';
import { bookingSubmitRedirect } from '../../../utils/location';
import Dialog from '../../shared/dialog/dialog';
import { addressService } from '../../../service/address.service';
import { postcodeRegExp } from '../../../utils/regexp';
import useWidgetView from '../../../hooks/useWidgetView';
import { BOOKING_TYPES, defaultButtonTypes, bookingTypes, initialFormData } from '../constants';
import { clearLocalStorage } from '../../../utils/localStorage';
import { BOOKING_STORAGE_DATA } from '../../membership/constants';
import usePatientInfo from '../hooks/usePatientinfo';
import ErrorDialog from "../page/error-dialog";
import { redirectToLocal } from '../../../utils/location';

export default function BookingWidget({ type = BOOKING_TYPES.VISIT, buttonsData = null }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [bookingType, setBookingType] = useState(BOOKING_TYPES.VISIT);

  const buttonsVisitDataJson = JSON.parse(buttonsData?.visit?.replaceAll("'", '"'));
  const buttonsVideoDataJson = JSON.parse(buttonsData?.video?.replaceAll("'", '"'));

  const [buttonVisitText, setButtonVisitText] = useState('Get price');
  const [buttonVideoText, setButtonVideText] = useState('Get price');

  const patient = usePatientInfo(); // CR 4
  const { activeTab, adaptiveArrow, handleChangeTab, handleClickArrow } = useWidgetView(
    +(type === BOOKING_TYPES.VISIT) || 2,
  );

  const handleSubmit = (type, date, time, postcode, address, appointmentType) => {
    clearLocalStorage([BOOKING_STORAGE_DATA.BOOKING_DATA, BOOKING_STORAGE_DATA.BOOKING_QUERY]);

    if (!postcode) {
      return bookingSubmitRedirect(type, date, time, null, null, appointmentType);
    }

    const isValid = postcodeRegExp.test(postcode);

    if (!isValid) return setIsOpen(true);

    setIsLoaded(true);

    addressService
      .isValidPostcode(postcode)
      .then(({ supported, notSupportedMessage }) => {
        setIsLoaded(false);

        if (supported) {
          return bookingSubmitRedirect(type, date, time, postcode, address);
        }

        const message = notSupportedMessage ? notSupportedMessage : 'Sorry, we do not provide service in this postcode area';
        setErrorMessage(message);
        setIsError(true);
      })
      .catch(() => setIsLoaded(false));
  };

  const handleChangeBookingType = (name, value) => {
    setBookingType(value)
  }

  const onCloseDialog = () => {
    setIsOpen(false);
  };

  const closeModal = () => {
    setIsError(false);
    setErrorMessage('');
  };

  useEffect(() => {
    if (patient?.membership) {
      const name = patient.membership.program.name.toLowerCase().replaceAll(' ', '');
      setButtonVisitText(buttonsVisitDataJson[name]);
      setButtonVideText(buttonsVideoDataJson[name]);
    } else if (patient) {
//      setButtonVisitText(buttonsVisitDataJson[defaultButtonTypes.withoutMembership]);
//      setButtonVideText(buttonsVideoDataJson[defaultButtonTypes.withoutMembership]);
    }
  }, [patient]);

  const handleJoinTab = () => {
    if (!patient?.membership) {
      redirectToLocal('/visiting-doctor-membership');
    } else return;

  }

  return (
    <div className={classnames('booking-widget-wrapper', !adaptiveArrow ? 'open' : 'close')}>
      <div className="booking-widget__tabs">
        <TabNavItem
          title="Book"
          id="tab1"
          activeTab={activeTab}
          adaptiveArrow={adaptiveArrow}
          handleClickArrow={handleClickArrow}
          onTabChange={handleChangeTab}
          className={classnames('booking-widget__tab', 'tpg_buttons')}
        />
        { !patient?.membership &&
          <TabNavItem
            title="Join"
            id="tab2"
            activeTab={activeTab}
            onTabChange={handleJoinTab}
            className={classnames('booking-widget__tab booking-widget__tab_without-arrow', 'tpg_buttons')}
          />
        }
      </div>
      <div className="booking-widget__body">
        <div className="booking-widget__logo-container">
          <Logo className="booking-widget__logo" />
        </div>
        <RadioButtonGroup
          value={bookingType}
          name="bookingType"
          onChange={handleChangeBookingType}
          options={bookingTypes}
          className="radio-button-group"
        />

        <TabContent activeTab={activeTab} id="tab1">
          {(bookingType === BOOKING_TYPES.VISIT) && (
            <VisitWidget handleSubmit={handleSubmit} buttonText={buttonVisitText} patient={patient} />
          )}

          {(bookingType === BOOKING_TYPES.APPOINTMENT) && (
            <BookingAppointment handleSubmit={handleSubmit} buttonText={buttonVideoText} />
          )}
        </TabContent>

        {isLoaded && (
          <div className="tab__content__loader">
            <div className="tab__content__loader-overlay">
              <Preloader classname="preloader-white" />
            </div>
          </div>
        )}
        {!adaptiveArrow && <span onClick={handleClickArrow} className="tab__nav-arrow icon-arrow-small" />}
      </div>
      {isOpen && (
        <Dialog onClose={onCloseDialog} className="booking__modal">
          <div className="booking__dialog-content">
            <span className="tpg_b1">
              Telephone or video consultation is available. Alternatively, please contact us on 0344 257 0345 or email
              us on <a href="mailto:team247@doctorcall.co.uk">team247@doctorcall.co.uk</a>. We will be happy to help.
            </span>
          </div>
        </Dialog>
      )}
      {isError && (
        <ErrorDialog onClose={closeModal} error={errorMessage}>
          Please contact us on 0344 257 0345 or email{' '}
          <a href="mailto:team247@doctorcall.co.uk">team247@doctorcall.co.uk</a> where we will be happy to help.
        </ErrorDialog>
      )}
    </div>
  );
}
